import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const getInitialState = () => {
  const token = localStorage.getItem("token");

  if (token) {
    try {
      const decoded = jwtDecode(token);

      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        localStorage.removeItem("token");
        return {
          token: null,
          user: null,
          isAuthenticated: false,
        };
      }

      return {
        token,
        user: {
          emailAddress: decoded.emailAddress,
          role: decoded.role,
          userId: decoded.userId,
        },
        isAuthenticated: true,
      };
    } catch (error) {
      console.error(error);
      localStorage.removeItem("token");

      return {
        token: null,
        user: null,
        isAuthenticated: false,
      };
    }
  }

  return {
    token: null,
    user: null,
    isAuthenticated: false,
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState: getInitialState(),
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      localStorage.setItem("token", action.payload.token);
    },

    clearCredentials: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
